import {
  isArticlePage,
  isFreeHtmlPage,
  isGalleryPage,
  isLiveBlogPage,
  isNewsYouCanUsePage,
  isSportsDataLiveMatchPage,
  isSportsDataLiveGpPage,
} from '../../utils/aem-utils';

export const primaryTagModule = {
  name: 'Primary Tag',
  shouldInit: () => {
    const isOneOfChosenTemplates =
      isArticlePage() ||
      isGalleryPage() ||
      isLiveBlogPage() ||
      isFreeHtmlPage() ||
      isSportsDataLiveMatchPage() ||
      isSportsDataLiveGpPage() ||
      isNewsYouCanUsePage();
    return isOneOfChosenTemplates;
  },
};
